import { render, staticRenderFns } from "./case_new.vue?vue&type=template&id=f01af9a6&scoped=true"
import script from "./case_new.vue?vue&type=script&lang=js"
export * from "./case_new.vue?vue&type=script&lang=js"
import style0 from "./case_new.vue?vue&type=style&index=0&id=f01af9a6&prod&scoped=true&lang=less"
import style1 from "./case_new.vue?vue&type=style&index=1&id=f01af9a6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01af9a6",
  null
  
)

export default component.exports